import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useApiAuth } from '@/modules/auth-api'

export function AdminGuard({ children }: { children: ReactNode }) {
  const user = useApiAuth((s) => s.user)
  const isAuthed = useApiAuth((s) => s.isAuthed)
  const location = useLocation()

  if (!isAuthed || user?.role !== 'ADMIN') {
    return <Navigate to="/admin/dang-nhap" replace state={{ from: location.pathname }} />
  }
  return <>{children}</>
}
